import JrwaTab from "./JrwaTab";
import styles from "./styles.module.scss";

const DictionariesTab = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <JrwaTab />
      </div>
    </div>
  );
};

export default DictionariesTab;
